module.exports = __webpack_public_path__ + "img/kitchen.f8e13cb.jpeg";